angular.module('CaresApp').filter('percent', function() {
  return function(input) {
    if (!input || isNaN(input)) {
      return undefined;
    }
    return `${Math.round(input)}%`;
  };
});
